import userSelectFinder from "./userSelectFinder.vue";
export default userSelectFinder;
